import {authAPI} from '@/api/restfulAPI'
import { AES, enc, mode, pad, MD5 } from 'crypto-js';

function loginEncrypt (username, password) {
  // Calculate MD5 hash of the username and convert it to lowercase
  const md5Username = MD5(username).toString().toLowerCase();

  // Take the first 16 characters of the md5Username as the encryption key
  const encryptionKey = md5Username.substring(0, 32);
  // Use the first 16 characters of the encryption key as the initialization vector (IV)
  const iv = encryptionKey.substring(0, 16);

  const key = enc.Utf8.parse(encryptionKey);

  const encryptedPassword = AES.encrypt(password, key, {
    iv: enc.Utf8.parse(iv),
    mode: mode.CBC,
    padding: pad.Pkcs7
  }).toString();

  // 將加密結果轉為 Hex 編碼
  // const hexCiphertext = enc.Hex.stringify(encryptedPassword);
  // 輸出加密結果
  // console.log('hexCiphertext: ', hexCiphertext);
  return encryptedPassword;
  // Convert the AES encrypted password to Base64
  // const base64EncryptedPassword = Buffer.from(encryptedPassword).toString('base64');
  // Convert the AES encrypted password to Base64 using btoa function
  // console.log('Base64:', enc.Base64.parse(encryptedPassword).toString());
  // const base64EncryptedPassword = btoa(encryptedPassword);
  // return base64EncryptedPassword;
}

// function D(){
//   const key = enc.Utf8.parse('1305dc4a7c6ade2e84ca099430c2b5e9');
// const iv = enc.Utf8.parse('1305dc4a7c6ade2e');

// const encrypted = AES.encrypt('P@ssw0rd', key, {
//   iv,
//   mode: mode.CBC,
//   padding: pad.Pkcs7,
// });

// const base64 = encrypted.toString();
// // var base64 = encrypted.ciphertext.toString();

// console.log(base64);
// return base64;
// }
function loginDecrypt(username, encryptStr) {
  // Calculate MD5 hash of the username and convert it to lowercase
  const md5Username = MD5(username).toString().toLowerCase()
  // Take the first 16 characters of the md5Username as the encryption key
  const encryptionKey = md5Username.substring(0, 32)
  // Use the first 16 characters of the encryption key as the initialization vector (IV)
  const iv = encryptionKey.substring(0, 16)
  const key = enc.Utf8.parse(encryptionKey)
  // const key = enc.Utf8.parse('1305dc4a7c6ade2e84ca099430c2b5e9');
  // const iv = enc.Utf8.parse('1305dc4a7c6ade2e');
  const base64 = encryptStr

  var encryptedHexStr = enc.Base64.parse(base64);
  var encryptedBase64Str = enc.Base64.stringify(encryptedHexStr);
  const encrypted = encryptedBase64Str;

  const decrypted = AES.decrypt(encrypted, key, {
    iv,
    mode: mode.CBC,
    padding: pad.Pkcs7
  });

  const originalText = decrypted.toString(enc.Utf8);

  console.log(originalText);
  return originalText
}

function loginWithPwd (username, pwd, type, tokenTs) {
  const newPwd = loginEncrypt(username, pwd)
  return authAPI.loginWithPwd(username, newPwd, type, tokenTs, { isEncrypted: true })
}

export default {loginEncrypt, loginDecrypt, loginWithPwd}



// WEBPACK FOOTER //
// ./src/api/cryptoLogin.js